/* global axios */
import ApiClient from './ApiClient';

class AudiencesAPI extends ApiClient {
  constructor() {
    super('audiences', { accountScoped: true });
  }

  getContacts(id, page = 1) {
    return axios.get(`${this.url}/${id}/contacts`, { params: { page } });
  }

  preview(criteria, signal) {
    return axios.post(`${this.url}/preview`, { criteria }, { signal });
  }
}

export default new AudiencesAPI();
